// @ts-nocheck
const CheckQtyBudget = () => {
  var hasQty = false;
  if (JShippingRate.Qty == '')
    JShippingRate.Qty = '0';
  if (parseInt(JShippingRate.Qty) > 0)
    hasQty = true;
  var hasBudget = false;
  //@ts-ignore
  if (JShippingRate.lowestTotal != '' || JShippingRate.highestTotal != '')
    hasBudget = true;

  if (!hasBudget && !hasQty)
    return 'Please input at least one of the quantity or budget';

  //@ts-ignore
  if (JShippingRate.lowestTotal != '' && JShippingRate.highestTotal != '' && parseFloat(JShippingRate.lowestTotal) > parseFloat(JShippingRate.highestTotal))
    return 'Please fix low / high price fields';

  return '';

}

Object.assign(globalThis, {
  CheckQtyBudget
})